export default {
  Welcome: "Bienvenue, ",
  "Employer Portal": "Portail Employeur",
  "Select files": "Sélectionnez les fichiers"
};
